<template>
  <b-row>
    <StepperCol :step="3" />
    <b-col cols="10" md="11" class="pb-4">
      <h5
        class="h3 font-weight-normal mb-4"
        :class="collapsed ? '' : 'text-muted'"
      >
        回収するエアコンはありますか？
      </h5>
      <b-collapse v-model="shrinking" class="d-md-none">
        <b-button
          variant="outline-warning"
          size="lg"
          class="btn-gd text-left position-relative py-2"
          block
          @click="shrinking = false"
        >
          <span class="h4 m-0">{{
            a0Selected
              ? "回収を依頼しない"
              : a1Selected
              ? "回収を依頼する(2012年以降)"
              : "回収を依頼する(2011年以前)"
          }}</span>
          <div class="d-block text-muted">
            {{ a0Selected ? "¥0-" : a1Selected ? "¥0~" : "¥3,300-" }}
          </div>
          <div class="accessory-shrinking">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 12 12"
            >
              <polyline
                fill="none"
                stroke="#FD9000"
                stroke-width="2"
                points="0,6 6,11 12,6"
              />
            </svg>
          </div>
        </b-button>
      </b-collapse>
      <b-collapse v-model="isCollapsed">
        <b-form-row>
          <b-col cols="12" md="4" class="mb-3">
            <b-button
              class="btn-gd text-left p-0 h-120px"
              :class="a0Selected ? 'selected' : ''"
              @click="buttonClicked(0)"
            >
              <b-row no-gutters class="h-100">
                <b-col
                  cols="6"
                  class="py-3 pl-3 d-flex flex-column justify-content-between"
                >
                  <h6 class="h4">回収を<br />依頼しない</h6>
                  <dl class="text-muted mb-0">
                    <dt>運搬処分費</dt>
                    <dd class="font-weight-bold h5 mb-0">
                      ¥<span class="h3 ml-1">0-</span>
                    </dd>
                  </dl>
                </b-col>
                <b-col cols="6" class="py-3 px-1">
                  <b-img
                    :src="require('@/assets/images/q-2-1@2x.png')"
                    fluid
                  ></b-img>
                </b-col>
              </b-row>
            </b-button>
          </b-col>
          <b-col cols="12" md="4" class="mb-3">
            <b-button
              class="btn-gd text-left p-0 h-120px"
              :class="a1Selected ? 'selected' : ''"
              @click="buttonClicked(1)"
            >
              <b-row no-gutters class="h-100">
                <b-col
                  cols="6"
                  class="py-3 pl-3 d-flex flex-column justify-content-between"
                >
                  <h6 class="h4">回収を<br />依頼する</h6>
                  <dl class="text-muted mb-0">
                    <dt>運搬処分費</dt>
                    <dd class="font-weight-bold h5 mb-0">
                      ¥<span class="h3 ml-1">0~</span>
                    </dd>
                  </dl>
                </b-col>
                <b-col cols="6" class="py-3 px-1">
                  <b-img
                    :src="require('@/assets/images/q-2-2@2x.png')"
                    fluid
                  ></b-img>
                  <div class="pr-3 text-center text-primary">
                    製造年式<br />2012年以降
                  </div>
                </b-col>
              </b-row>
            </b-button>
          </b-col>
          <b-col cols="12" md="4" class="mb-3">
            <b-button
              class="btn-gd text-left p-0 h-120px"
              :class="a2Selected ? 'selected' : ''"
              @click="buttonClicked(2)"
            >
              <b-row no-gutters class="h-100">
                <b-col
                  cols="6"
                  class="py-3 pl-3 d-flex flex-column justify-content-between"
                >
                  <h6 class="h4">回収を<br />依頼する</h6>
                  <dl class="text-muted mb-0">
                    <dt>運搬処分費</dt>
                    <dd class="font-weight-bold h5 mb-0">
                      ¥<span class="h3 ml-1">3,300~</span>
                    </dd>
                  </dl>
                </b-col>
                <b-col cols="6" class="py-3 px-1">
                  <b-img
                    :src="require('@/assets/images/q-2-2@2x.png')"
                    fluid
                  ></b-img>
                  <div class="pr-3 text-center text-primary">
                    製造年式<br />2011年以前
                  </div>
                </b-col>
              </b-row>
            </b-button>
          </b-col>
        </b-form-row>
      </b-collapse>
    </b-col>
  </b-row>
</template>

<script>
import StepperCol from "../StepperCol";
import { mapState, mapActions } from "vuex";

export default {
  components: {
    StepperCol,
  },
  data() {
    return {
      collapsed: false,
      shrinking: false,
      a0Selected: false,
      a1Selected: false,
      a2Selected: false,
    };
  },
  watch: {
    currentStep(val, old) {
      // eslint-disable-line
      val;
      old;
    },
    maxStep(val, old) {
      // eslint-disable-line
      old;
      if (val >= 3) {
        this.collapsed = true;
      }
    },
  },
  computed: {
    ...mapState({
      currentStep() {
        return this.$store.getters.currentStep;
      },
      maxStep() {
        return this.$store.getters.maxStep;
      },
    }),
    isCollapsed: {
      get() {
        if (this.shrinking) {
          if (window.innerWidth < 576) {
            return false;
          } else {
            return true;
          }
        } else {
          return this.collapsed;
        }
      },
      set(value) {
        // eslint-disable-line
        value;
      },
    },
  },
  methods: {
    reset() {
      this.shrinking = false;
      this.collapsed = false;
      this.a0Selected = false;
      this.a1Selected = false;
      this.a2Selected = false;
    },
    ...mapActions({
      doUpdateStep: "doUpdateStep",
      doSaveAnswer: "doSaveAnswer",
    }),
    buttonClicked(value) {
      if (value == 0) {
        this.a0Selected = true;
        this.a1Selected = false;
        this.a2Selected = false;
      } else if (value == 1) {
        this.a0Selected = false;
        this.a1Selected = true;
        this.a2Selected = false;
      } else {
        this.a0Selected = false;
        this.a1Selected = false;
        this.a2Selected = true;
      }
      this.doSaveAnswer({ keyword: 'has_recycling', answer: value });
      this.doUpdateStep(4);
      this.shrinking = true;
    },
  },
};
</script>